import styled from 'styled-components';
import { FlexContainer, FlexColumn } from '../common/Flex';
import { breakpoints } from '../../breakpoints';

export const Header = styled(FlexContainer)`
  align-items: flex-start;
  margin-bottom: 45px;
  margin-top: 40px;

  /* Keep logo and text side-by-side until xs breakpoint */
  flex-wrap: nowrap;

  /* Allow wrapping only on very small screens (xs) */
  @media (max-width: ${breakpoints.maxWidthXs}) {
    flex-wrap: wrap;
  }
`;

export const HeaderText = styled(FlexColumn)`
  margin-top:auto;
  text-align:right;
  align:right;
  align-items:right;
  font-size:calc(1.5rem - 2px);
  flex-grow:1; //==scaleSmall=1

  @media (max-width: ${breakpoints.maxWidthXs}) {
    flex: 0 0 100%;
    width: 100%;
    text-align: left;
  }
`;